import { STTypo, STTypoModels } from '@protector/components';
import classNames from 'classnames';
import { COLOR_OPTIONS } from 'config/style';
import { useTranslation } from 'react-i18next';
import StatusTag from '../status-tag/status-tag.component';
import type { Status } from '../status-tag/status-tag.model';
import { StatusTypeEnum } from '../status-tag/status-tag.model';
import styles from './seven-day-total-tag.module.css';

export interface SevenDayTotalTagProps {
  total: number | string;
  status: Status;
  className?: string;
}

export const SevenDayTotalTag = ({ total, status, className }: SevenDayTotalTagProps) => {
  const [t] = useTranslation();

  return (
    <div className={classNames(styles.total, className)}>
      <STTypo type={STTypoModels.TypeOptions.C2} fontFamily='Noto Sans' color={COLOR_OPTIONS.NEUTRAL_60} lineHeight='15px'>
        {t('pages.regional_overview.digital_traps.7_days_total')}
      </STTypo>
      <StatusTag
        tagValue={total}
        type={StatusTypeEnum.SEVEN_DAY_TOTAL}
        status={status}
        tagPadding='0 6px'
        tagColor={COLOR_OPTIONS.NEUTRAL_100}
      />
    </div>
  );
};
